import * as React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'

import { Button, Card, Typography } from '@material-ui/core'
import classNames from 'classnames'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import ReactSVG from 'react-svg'

import { isAndroid, isIOS } from 'react-device-detect'

import { appStoreLink, googlePlayLink } from 'config/appLinks'
import { sendDownloadEmail } from '../../../services/email'
import SnackbarService from '../../../services/snackbars'

import BlueBalloon from 'assets/img/balloons/blue_balloon.svg'
import AppleIcon from '../../../assets/img/apple.svg'
import PurpleBalloon from '../../../assets/img/balloons/purple_balloon.svg'
import YellowBalloon from '../../../assets/img/balloons/yellow_balloon.svg'
import GooglePlayIcon from '../../../assets/img/googleplay.svg'
import LinkIcon from '../../../assets/img/link.svg'

// import { Header } from 'components'

import './styles.scss'

interface INativeProps {
  onSubmit?: () => void
  goBackAction: () => void
  disableBackButton: boolean
}

interface IReduxStateProps {
  user: any
}

interface IProps extends INativeProps, IReduxStateProps {}

enum Page {
  thisDevice = 'this-device',
  anotherDevice = 'another-device'
}

// const pages = [Page.thisDevice, Page.anotherDevice]

interface IState {
  page: Page
}

class EvaluationGame extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      page: this.deviceLink() ? Page.thisDevice : Page.anotherDevice
    }
  }

  goBackAction = () => {
    const { goBackAction } = this.props
    const { page } = this.state
    if (this.deviceLink() && page === Page.anotherDevice) {
      this.moveTo(Page.thisDevice)
    } else {
      goBackAction()
    }
  }

  deviceLink = () => {
    if (isIOS) {
      return appStoreLink
    } else if (isAndroid) {
      return googlePlayLink
    } else {
      return ''
    }
  }

  sendDownloadEmail = (link: string) => {
    const { user } = this.props
    sendDownloadEmail(user.email, link, user.full_name)
  }

  moveTo = (page: Page) => {
    this.setState({ page })
  }

  renderThisDeviceLinks = () => {
    return (
      <>
        <Button
          className="btn download-btn"
          onClick={() => window.open(this.deviceLink())}
        >
          INSTALL ON THIS DEVICE
        </Button>
        <Button
          className="btn download-btn white-btn"
          onClick={() => this.moveTo(Page.anotherDevice)}
        >
          INSTALL ON ANOTHER DEVICE
        </Button>
      </>
    )
  }

  onSend = (link: string) => () => {
    this.sendDownloadEmail(link)
    SnackbarService.showSnackbar('We sent a link to your email', 'info')
  }

  renderAnotherDeviceLinks = () => {
    return (
      <>
        <div className="send-emails">
          <Button
            className="send-email-btn"
            onClick={this.onSend(appStoreLink)}
          >
            <ReactSVG className="send-email-img apple-icon" src={AppleIcon} />
            <div className="info">
              <Typography className="small">send iOS link</Typography>
              <Typography className="text">By Email</Typography>
            </div>
          </Button>
          <Button
            className="send-email-btn"
            onClick={this.onSend(googlePlayLink)}
          >
            <ReactSVG
              className="send-email-img google-play-icon"
              src={GooglePlayIcon}
            />
            <div className="info">
              <Typography className="small">send Android link</Typography>
              <Typography className="text">By Email</Typography>
            </div>
          </Button>
        </div>
        <div className="copy-links">
          <div className="copy">
            <Typography className="small">copy app store link</Typography>
            <CopyToClipboard
              text={appStoreLink}
              onCopy={() =>
                SnackbarService.showSnackbar('Link copied to clipboard', 'info')
              }
            >
              <Button className="copy-btn">
                <div className="copy-container">
                  <div className="link-icon-container">
                    <ReactSVG className="link-icon" src={LinkIcon} />
                  </div>
                  <Typography className="link">{appStoreLink}</Typography>
                </div>
              </Button>
            </CopyToClipboard>
          </div>

          <div className="copy">
            <Typography className="small">copy google play link</Typography>
            <CopyToClipboard
              text={googlePlayLink}
              onCopy={() =>
                SnackbarService.showSnackbar('Link copied to clipboard', 'info')
              }
            >
              <Button className="copy-btn">
                <div className="copy-container">
                  <div className="link-icon-container">
                    <ReactSVG className="link-icon" src={LinkIcon} />
                  </div>
                  <Typography className="link">{googlePlayLink}</Typography>
                </div>
              </Button>
            </CopyToClipboard>
          </div>
        </div>
      </>
    )
  }

  downlaods = () => {
    const { page } = this.state
    switch (page) {
      case Page.thisDevice:
        return this.renderThisDeviceLinks()
      case Page.anotherDevice:
        return this.renderAnotherDeviceLinks()
      default:
        return null
    }
  }

  render() {
    const { onSubmit /*, disableBackButton*/ } = this.props
    const { page } = this.state
    return (
      <div className="instruction-page">
        {/* <Header
          title="Game Installation"
          smallHeader={true}
          oneRow={true}
          goBackAction={this.goBackAction}
          disableBackButton={disableBackButton}
        /> */}
        <div className="mobile-container">
          <div className="evaluation-game instruction">
            <div className="content">
              <Card className="card">
                <Typography className="card-title">Evaluation Game</Typography>
                <Typography className="card-text">
                  The GiantLeap Evaluation Game is a separate app available for
                  iOS and Android devices. Install the app and play the games
                  together with your child
                </Typography>
                <div className={classNames('downloads', page)}>
                  {this.downlaods()}
                </div>
              </Card>
              <div className="next-btn-container">
                <Button onClick={onSubmit} className="btn next-btn">
                  Done
                </Button>
              </div>
            </div>
            <div className="balloons">
              <ReactSVG src={BlueBalloon} className="balloon blue-balloon" />
              <ReactSVG
                src={YellowBalloon}
                className="balloon yellow-balloon"
              />
              <ReactSVG
                src={PurpleBalloon}
                className="balloon purple-balloon"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.user.data
})

const connector = connect<IReduxStateProps, {}, INativeProps>(mapStateToProps)

export default compose(connector)(EvaluationGame)



// WEBPACK FOOTER //
// ./src/pages/Instructions/EvaluationGame/index.tsx